import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ExportSequenceMutationVariables = Types.Exact<{
  fileName: Types.Scalars['String']['input'];
  presetId: Types.Scalars['ID']['input'];
  fullSequence: Types.Scalars['Boolean']['input'];
  filePath?: Types.InputMaybe<Types.Scalars['String']['input']>;
  format?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ExportSequenceMutation = { __typename?: 'Mutation', exportSequence: { __typename?: 'ExportSequencePayload', filePath?: string | null, batchItemId?: string | null } };


export const ExportSequence = /*#__PURE__*/ gql`
    mutation ExportSequence($fileName: String!, $presetId: ID!, $fullSequence: Boolean!, $filePath: String, $format: String) {
  exportSequence(
    fileName: $fileName
    presetId: $presetId
    fullSequence: $fullSequence
    filePath: $filePath
    format: $format
  ) {
    filePath
    batchItemId
  }
}
    ` as unknown as DocumentNode<ExportSequenceMutation, ExportSequenceMutationVariables>;

          

          export const useExportSequenceMutation = (options?:MutationHookOptions<ExportSequenceMutation, ExportSequenceMutationVariables>) => useMutation(ExportSequence, options);
          

          export type ExportSequenceMutationOptions = MutationHookOptions<ExportSequenceMutation, ExportSequenceMutationVariables>;

          

          export type ExportSequenceMutationResult = ReturnType<typeof useExportSequenceMutation>[1];

          
